import * as React from "react";
import { forwardRef } from "react";
const SvgCaretDownSmall = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 7 4",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M6.13 0 3.5 2.41.87 0 0 .8 3.5 4 7 .8 6.13 0Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgCaretDownSmall);
export default ForwardRef;
